declare namespace $ {

	type $mol_view__sub_bog_wikilive_app_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_wikilive_app_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Home_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_wikilive_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_wikilive_app_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['home_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_wikilive_app_5 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['nav_home'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_wikilive_app_6 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Search_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_wikilive_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_wikilive_app_8 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['search_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_wikilive_app_9 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['nav_search'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_wikilive_app_10 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Profile_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_wikilive_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_wikilive_app_12 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['profile_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_wikilive_app_13 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['nav_profile'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_app_15 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['add_menu_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_app_17 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_create_blank'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_app_19 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_create_meeting'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_app_21 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_create_spec'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_app_23 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_create_guide'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_pop__showed_bog_wikilive_app_24 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['add_menu_showed'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_bog_wikilive_app_25 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Add_page'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_wikilive_app_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_view__sub_bog_wikilive_app_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sidebar__mode_bog_wikilive_app_28 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['sidebar_mode'] >
		,
		ReturnType< $bog_ui_sidebar['mode'] >
	>
	type $bog_ui_sidebar__Header_bog_wikilive_app_29 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Nav_header'] >
		,
		ReturnType< $bog_ui_sidebar['Header'] >
	>
	type $bog_ui_sidebar__items_bog_wikilive_app_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sidebar['items'] >
	>
	type $bog_ui_sidebar__Footer_bog_wikilive_app_31 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['Nav_footer'] >
		,
		ReturnType< $bog_ui_sidebar['Footer'] >
	>
	type $mol_view__sub_bog_wikilive_app_32 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['content_pages'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_wikilive_app_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $bog_wikilive_tree__store_bog_wikilive_app_34 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['store'] >
		,
		ReturnType< $bog_wikilive_tree['store'] >
	>
	type $bog_wikilive_tree__page_selected_bog_wikilive_app_35 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_selected'] >
		,
		ReturnType< $bog_wikilive_tree['page_selected'] >
	>
	type $bog_wikilive_page__store_bog_wikilive_app_36 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['store'] >
		,
		ReturnType< $bog_wikilive_page['store'] >
	>
	type $bog_wikilive_page__page_link_bog_wikilive_app_37 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_selected'] >
		,
		ReturnType< $bog_wikilive_page['page_link'] >
	>
	type $mol_page__title_bog_wikilive_app_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_wikilive_app_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $bog_wikilive_profile_page__store_bog_wikilive_app_40 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['store'] >
		,
		ReturnType< $bog_wikilive_profile_page['store'] >
	>
	type $bog_wikilive_profile_page__page_selected_bog_wikilive_app_41 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_selected'] >
		,
		ReturnType< $bog_wikilive_profile_page['page_selected'] >
	>
	type $bog_wikilive_search__store_bog_wikilive_app_42 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['store'] >
		,
		ReturnType< $bog_wikilive_search['store'] >
	>
	type $bog_wikilive_search__page_selected_bog_wikilive_app_43 = $mol_type_enforce<
		ReturnType< $bog_wikilive_app['page_selected'] >
		,
		ReturnType< $bog_wikilive_search['page_selected'] >
	>
	export class $bog_wikilive_app extends $mol_book2 {
		Theme( ): $mol_theme_auto
		sidebar_mode( next?: string ): string
		Logo( ): $bog_wikilive_logo
		Nav_header( ): $mol_view
		Home_icon( ): $mol_icon_home
		home_active( ): boolean
		nav_home( next?: any ): any
		Home_nav( ): $bog_ui_sidebar_item
		Search_icon( ): $mol_icon_magnify
		search_active( ): boolean
		nav_search( next?: any ): any
		Search_nav( ): $bog_ui_sidebar_item
		Profile_icon( ): $mol_icon_account
		profile_active( ): boolean
		nav_profile( next?: any ): any
		Profile_nav( ): $bog_ui_sidebar_item
		add_menu_showed( next?: boolean ): boolean
		add_menu_toggle( next?: any ): any
		Add_page( ): $mol_button_minor
		page_create_blank( next?: any ): any
		Add_blank( ): $mol_button_minor
		page_create_meeting( next?: any ): any
		Add_meeting( ): $mol_button_minor
		page_create_spec( next?: any ): any
		Add_spec( ): $mol_button_minor
		page_create_guide( next?: any ): any
		Add_guide( ): $mol_button_minor
		Add_menu( ): $mol_pop
		Lighter( ): $mol_lights_toggle
		Nav_footer( ): $mol_view
		Nav( ): $bog_ui_sidebar
		content_pages( ): readonly(any)[]
		Content( ): $mol_view
		page_selected( next?: string ): string
		Welcome_text( ): $mol_text
		plugins( ): readonly(any)[]
		pages( ): readonly(any)[]
		Tree( ): $bog_wikilive_tree
		Page( ): $bog_wikilive_page
		Welcome( ): $mol_page
		Profile( ): $bog_wikilive_profile_page
		Search( ): $bog_wikilive_search
		store( ): $bog_wikilive_store
		screen( next?: string ): string
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map